export const DRIVE_FETCH_DEFAULT_MAX_BYTES = 100 * 1024 * 1024;
export const DRIVE_PIN_MAX_BYTES = 100 * 1024 * 1024;
export const DRIVE_TEXT_EXTRACTION_CADENCE_MINUTES = 15;
export const DRIVE_TEXT_EXTRACTION_MAX_FILES = 50;
export const DRIVE_TEXT_EXTRACTION_MAX_BYTES = 200 * 1024 * 1024;
export const DRIVE_FIND_SCAN_LIMIT = 2_000;
